module.exports = __webpack_public_path__ + "media/recipes/129-5d1ff86f.png";